<template>
  <div>
      <div class="constructor" id="gjs">
    </div>
    <button class="constructor-btn" @click.prevent="openModal('createTemplateModal')">Сохранить</button>
    <InputModal
      ref="createTemplateModal"
      v-model="value"
      title="Введите название для файла"
      buttonName="Создать"
      @submit="postFile" />
  </div>
</template>
<script>

import * as grapesjs from '@/assets/grapes/grapes.min.js'
import '@/assets/grapes/grapes.min.css'
import * as gjs from 'grapesjs-preset-webpage';
import basicBlocks from '@/assets/grapes/grapes.blocks.min.js';
import * as news from 'grapesjs-preset-newsletter';
import ViewWithModalsMixin from "@/mixins/ViewWithModalsMixin"
import InputModal from '@/components/InputModal.vue'

export default {
  name: 'PageConstructor',
  inject: ['filesAPI'],
  mixins: [ViewWithModalsMixin],
  components:{
    InputModal
  },
  data(){
    return{
      editor : [],
      value: ''
    }
  },
  mounted(){
    this.editor = grapesjs.init({
     container: '#gjs',
     height: '750px',
     width: '100%',
     plugins: [gjs, basicBlocks, news],
     storageManager: {
       id: 'gjs-',
       type: 'local',
       autosave: true,
       storeComponents: true,
       storeStyles: true,
       storeHtml: true,
       storeCss: true
     },
     deviceManager: {
       devices:
       [
         {
           id: 'desktop',
           name: 'Desktop',
           width: '',
         },
         {
           id: 'tablet',
           name: 'Tablet',
           width: '768px',
           widthMedia: '992px',
         },
         {
           id: 'mobilePortrait',
           name: 'Mobile portrait',
           width: '320px',
           widthMedia: '575px',
         },
       ]
     },
     pluginsOpts: {
      [news]:{
          blocks: []
       },
       [basicBlocks]: {
          blocks: ['column1', 'column2', 'column3', 'text', 'image'],
       },
     },
   })
 },
 methods: {
  async postFile(){
    const data = this.editor.runCommand('gjs-get-inlined-html');
    const meta = '<meta charset="utf-8">';
    const viewport = '<meta name="viewport" content="width=device-width, initial-scale=1" />'
    const dataWithMeta = viewport + meta + data;
    const blob = new Blob([dataWithMeta], { type: "text/plain"});
    var today = new Date();
    const date = today.toLocaleString('en-US', {second:'2-digit', minute:'2-digit', hour:'2-digit'});
    const file = new File([blob], this.value === '' ? `Template ${date}.html` : `${this.value}.html`, {type: "html"})
    try{
      console.log(file);
      const res = await this.filesAPI.upload([file]);
      console.log(res)
    }catch(e){
      console.log(e);
    }
  }
 }
}
</script>
<style scoped>
  .constructor{
    z-index: 1;
  }
  .constructor-btn{
    display: block;
    margin: 25px auto 0;
    background-color: #463a3c;
    opacity: 0.8;
    color: #dddddd;
    font-size: 18px;
    border: 0px;
    border-radius: 5px;
    padding: 15px;
    cursor: pointer;
    transition: .3s all ease;
  }
  .constructor-btn:hover{
    opacity: 1;
  }
</style>